import { navLinks, dramaMeta } from '@/mocks/drama';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-16 max-w-7xl">
        <div className="grid gap-8 md:gap-10 grid-cols-1 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                <i className="ri-vidicon-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">漂亮的小姨子</span>
            </div>
            <p className="mt-4 font-body text-sm leading-relaxed text-secondary-200 max-w-md">
              本站为《漂亮的小姨子》短剧的内容导览页，围绕剧情速览、角色关系、全集分集导览、名场面与追更指南，帮助观众快速了解完整版、大结局与全集内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {dramaMeta.tags.map((tag) => (
                <span key={tag} className="rounded-full border border-secondary-700 px-3 py-1 font-label text-xs text-secondary-200">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-bold text-background-50">
              <a href="#intro" className="hover:text-accent-300 cursor-pointer">页面导航</a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-y-2">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={`#${link.id}`} className="font-body text-sm text-secondary-200 hover:text-accent-300 cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-bold text-background-50">
              <a href="#guide" className="hover:text-accent-300 cursor-pointer">观看提示</a>
            </h4>
            <ul className="mt-4 space-y-3 font-body text-sm text-secondary-200">
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" aria-hidden="true" />
                单集时长约 2–4 分钟，适合碎片时间观看。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-bookmark-3-line mt-0.5 text-accent-400" aria-hidden="true" />
                建议按相遇、同住、风波、大结局四个篇章顺序浏览。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-accent-400" aria-hidden="true" />
                页面内容为整理与导览性质，具体剧集以正式上线版本为准。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-label text-xs text-secondary-300">© {new Date().getFullYear()} 漂亮的小姨子 · 短剧内容导览</p>
          <a href="#top" className="font-label text-xs text-secondary-200 hover:text-accent-300 flex items-center gap-1 cursor-pointer">
            <i className="ri-arrow-up-line" aria-hidden="true" />
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}